// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"1c76c23a","147":"48198676","295":"e079de0d","362":"f001f188","574":"6c85020d","807":"7f78874b","818":"737f2cf7","899":"e4abdd6b","900":"815301c4","996":"8d309f5b"}[chunkId] + ".chunk.js";
};